// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AiChartController from "./ai_chart_controller"
application.register("ai-chart", AiChartController)

import AnnouncementBannerController from "./announcement_banner_controller"
application.register("announcement-banner", AnnouncementBannerController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BrokerPickerController from "./broker_picker_controller"
application.register("broker-picker", BrokerPickerController)

import ChartCaptureController from "./chart_capture_controller"
application.register("chart-capture", ChartCaptureController)

import ChartMarksEditorController from "./chart_marks_editor_controller"
application.register("chart-marks-editor", ChartMarksEditorController)

import ChartSettingsFormController from "./chart_settings_form_controller"
application.register("chart-settings-form", ChartSettingsFormController)

import ChartSyncController from "./chart_sync_controller"
application.register("chart-sync", ChartSyncController)

import ChartkickLoaderController from "./chartkick_loader_controller"
application.register("chartkick-loader", ChartkickLoaderController)

import DecimalFormatterController from "./decimal_formatter_controller"
application.register("decimal-formatter", DecimalFormatterController)

import FileCheckController from "./file_check_controller"
application.register("file-check", FileCheckController)

import FormClearController from "./form_clear_controller"
application.register("form-clear", FormClearController)

import ForumChartController from "./forum_chart_controller"
application.register("forum-chart", ForumChartController)

import ForumEditorController from "./forum_editor_controller"
application.register("forum-editor", ForumEditorController)

import ForumQuoteController from "./forum_quote_controller"
application.register("forum-quote", ForumQuoteController)

import ForumReportController from "./forum_report_controller"
application.register("forum-report", ForumReportController)

import HeroAnimationController from "./hero_animation_controller"
application.register("hero-animation", HeroAnimationController)

import HighchartController from "./highchart_controller"
application.register("highchart", HighchartController)

import HoldingsDisplayController from "./holdings_display_controller"
application.register("holdings-display", HoldingsDisplayController)

import IndexConstituentsController from "./index_constituents_controller"
application.register("index-constituents", IndexConstituentsController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import KeyboardHelpController from "./keyboard_help_controller"
application.register("keyboard-help", KeyboardHelpController)

import LabStudyChartController from "./lab_study_chart_controller"
application.register("lab-study-chart", LabStudyChartController)

import LightweightChartController from "./lightweight_chart_controller"
application.register("lightweight-chart", LightweightChartController)

import ModelBookChartController from "./model_book_chart_controller"
application.register("model-book-chart", ModelBookChartController)

import ModelBookNoteController from "./model_book_note_controller"
application.register("model-book-note", ModelBookNoteController)

import NavbarFitController from "./navbar_fit_controller"
application.register("navbar-fit", NavbarFitController)

import NumberFormatterController from "./number_formatter_controller"
application.register("number-formatter", NumberFormatterController)

import PlatformRotatorController from "./platform_rotator_controller"
application.register("platform-rotator", PlatformRotatorController)

import PortfolioPerformanceChartController from "./portfolio_performance_chart_controller"
application.register("portfolio-performance-chart", PortfolioPerformanceChartController)

import RrgChartController from "./rrg_chart_controller"
application.register("rrg-chart", RrgChartController)

import TableSortController from "./table_sort_controller"
application.register("table-sort", TableSortController)

import ThemeConstituentsController from "./theme_constituents_controller"
application.register("theme-constituents", ThemeConstituentsController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ThemesNavigatorController from "./themes_navigator_controller"
application.register("themes-navigator", ThemesNavigatorController)

import TickerAutocompleteController from "./ticker_autocomplete_controller"
application.register("ticker-autocomplete", TickerAutocompleteController)

import TickerChartController from "./ticker_chart_controller"
application.register("ticker-chart", TickerChartController)

import TipModalController from "./tip_modal_controller"
application.register("tip-modal", TipModalController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TradeKindController from "./trade_kind_controller"
application.register("trade-kind", TradeKindController)

import TradeTotalController from "./trade_total_controller"
application.register("trade-total", TradeTotalController)

import TradingviewChartController from "./tradingview_chart_controller"
application.register("tradingview-chart", TradingviewChartController)

import VcpAnnotationsController from "./vcp_annotations_controller"
application.register("vcp-annotations", VcpAnnotationsController)

import VcpStudyController from "./vcp_study_controller"
application.register("vcp-study", VcpStudyController)

import WatchlistSelectionController from "./watchlist_selection_controller"
application.register("watchlist-selection", WatchlistSelectionController)
